import { Modal, Button, Col, Row } from "react-bootstrap";
import { i18nValue } from '../functions';
import { T } from "react-translator-component";
import { isHostz, isHostzBecozy, isHostzBlackSummit, isHostzSanCarlo } from "../components/CheckIn/hotelConditions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlock } from "@fortawesome/free-solid-svg-icons";

const InfoModal2 = ({ hotelId, hotelCode, checkIn, roomCode, language, placeholders, show, setShow }) => {
    const getPlaceholderValueFromCheckin = (phKey) => {
        const placeholders = { ...checkIn?.placeholders }
        let ph_value = '--'
        console.log('checkinPlaceHolders', placeholders)
        console.log('phKey', phKey)
        console.log('placeholders?.[phKey]', placeholders?.[phKey])

        if (placeholders) {
            if (placeholders?.[phKey]) {
                const ph_values = placeholders[phKey];
                console.log('PH - values', ph_values);
                if (ph_values?.[language]) {
                    ph_value = ph_values[language];
                } else {
                    console.log('PH - value - default en-US', ph_values?.['en-US']);
                    if (ph_values?.['en-US']) {
                        ph_value = ph_values['en-US'];
                    }
                }
            }
        }
        return ph_value
    }

    const stripStyles = (html) => {
        // Crear un contenedor temporal
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Eliminar etiquetas <style>
        const styles = tempDiv.querySelectorAll('style');
        styles.forEach((style) => style.remove());

        // Eliminar atributos style
        const elementsWithStyle = tempDiv.querySelectorAll('[style]');
        elementsWithStyle.forEach((el) => el.removeAttribute('style'));

        // Devolver el HTML limpio
        return tempDiv.innerHTML;
    };


    // const { data: hotel } = useContext(HotelContext)
    return (
        <>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                className={`info-modal info-modal-access-instructions hotel-${hotelCode}`}
            >
                <div className="modal-content-custom">
                    <Modal.Body className="modal-body-custom">
                        <div className="text-center p-4 mb-4">
                            <div>
                                <FontAwesomeIcon icon={faUnlock} color="#CCC" style={{ fontSize: 50, marginBottom: 30 }} />
                            </div>

                            {/* {isHostz(hotelId) && (
                                <h3>{T("status.access_information")}</h3>
                            )}
                            {!isHostz(hotelId) && (
                                <h3>{T("status.access_code")}</h3>
                            )} */}


                            {/* {isHostzBecozy(hotelId) && (
                                <>
                                    <span className="font-size-sm">{T("status.access_code.main_door")}</span>
                                    <h6 className="font-weight-bold font-size-lg">5522</h6>
                                    <span className="font-size-sm">{T("status.access_code.room_door")}</span>
                                    <h6 className="font-weight-bold font-size-lg" dangerouslySetInnerHTML={{ __html: stripStyles(customPlaceholders(null, 'desc', language, placeholders)) }}></h6>
                                    <br></br>
                                    <div className="font-size-sm">{T("status.access_code.hostz-becozy")}</div>
                                </>
                            )} */}

                            {(isHostzSanCarlo(hotelId)) && (
                                <p>
                                    <br></br>
                                    <span dangerouslySetInnerHTML={{ __html: stripStyles(getPlaceholderValueFromCheckin('ROOM-ACCESS-INSTRUCTIONS')) }}></span>
                                </p>
                            )}

                        </div>
                    </Modal.Body>
                </div>
            </Modal >



        </>
    );
};

export default InfoModal2;
